export default __webpack_public_path__ + "static/media/ic_avalanche_16.c3c804d8.svg";